import { render, staticRenderFns } from "./TeamTypeIndex.vue?vue&type=template&id=1d636303"
import script from "./TeamTypeIndex.vue?vue&type=script&lang=js"
export * from "./TeamTypeIndex.vue?vue&type=script&lang=js"
import style0 from "./TeamTypeIndex.vue?vue&type=style&index=0&id=1d636303&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports